export class FolderReadStatusToggleNotification {
	public viewId: number;
	public isRead: boolean;
	public folderIds: string[];

	public static fromJson(other: any): FolderReadStatusToggleNotification {
		const instance = new FolderReadStatusToggleNotification();
		instance.viewId = other.ViewId;
		instance.isRead = other.IsRead;
		instance.folderIds = other.FolderIds;
		return instance;
	}
}
